// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3_q-c","columnTop":"styles_columnTop__1qvDY","name":"styles_name__2dYKr","value":"styles_value__2t-2b"};